import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kingstonConfig } from "./data";

export default function KingstonPage() {
  return <CityPageTemplate config={kingstonConfig} />;
}